import { Breed, BullListItem } from 'types';
import segmentFromBullOrBreed from './segmentFromBullOrBreed';

const segmentIconFromBullOrBreed = (target: BullListItem | Breed): string =>
  segmentFromBullOrBreed(target).includes('l')
    ? '/icons/milk-illustration-1-svgrepo-com.svg'
    : '/icons/food-meat-beef-stake.svg';

export default segmentIconFromBullOrBreed;
